import React, { useState, useEffect } from "react"; 
import * as apiUrl from "../../apiUrl";

function CollectionParallax() {
  const [CollectionParallax, setCollectionParallax] = useState({});

  useEffect(() => {
    const fetchCollectionParallax = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/collection/last-image-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCollectionParallax(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCollectionParallax();
  }, []);

  return (
    <div className="about-parallax-sec">
      <img
        src={`${apiUrl.apiUrl}/${CollectionParallax.last_image}`}
        className="img-fluid"
        alt="Luxury real estate Developer Dubai"
      />
    </div>
  );
}

export default CollectionParallax;
